module.exports = __webpack_public_path__ + "static/media/Basal_8100.58d11ce2.jpg";